import { REQUEST_FACEBOOK_PAGE_FANS_ONLINE_SUCCESS, REQUEST_FACEBOOK_PAGE_FANS_ONLINE_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function facebookPageFanOnline(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_FACEBOOK_PAGE_FANS_ONLINE_SUCCESS:
      
      return { data: action.payload.data, errors: null };
    case REQUEST_FACEBOOK_PAGE_FANS_ONLINE_FAILURE:
     
      return { data: [], errors: action.payload.response && action.payload.response.data.errors };
    default:
      return state;
  }
}

